<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <form class="build-scan-report-container" [formGroup]="locationEdwForm">
    <ion-row>
      <ion-col>
        <div class="form-group form-group-lg no-margin date-label">
          <span class="date-label-span">{{ CONSTS.DATE_LABEL }} </span>
        </div>
        <app-form-date-picker
          formControlName="date"
          class="report-date-picker"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [icon]="IMAGES.CALENDAR"
        ></app-form-date-picker>
      </ion-col>
    </ion-row>
    <ion-row class="margin-bottom-1">
      <ion-col>
        <app-form-select
          formControlName="routes"
          class="form-select"
          [label]="CONSTS.ROUTE_LABEL"
          [options]="routes"
        ></app-form-select>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-report-format
          [radioButtonValue]="locationEdwForm.get('reportFormat')?.value"
          (emitRadioChange)="radioChange($event)"
        ></app-report-format>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    locationEdwSummaryReport &&
    locationEdwSummaryReport.response.locationEDWSummary
  "
  [tableFontSize]="'10px'"
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasTotalRow]="true"
  [hasSingleSubHeaderView]="false"
>
  @if (locationEdwSummaryReport && locationEdwSummaryReport.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.SITE_CODE }}
            {{ locationEdwSummaryReport.response.siteCode }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.SITE_NAME }}
            {{ locationEdwSummaryReport.response.siteName }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.DATE }}
            {{ locationEdwSummaryReport.response.date }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
  <ng-container total-row>
    @if (locationEdwSummaryReport && locationEdwSummaryReport.response) {
      <table
        aria-hidden="true"
        class="pdf-total-table"
      >
        <tr class="pdf-total-row">
          <td class="pdf-total-cell">{{ PDF_REPORT.FOOTER.TOTAL }}</td>
          <td class="pdf-total-cell"></td>
          <td class="pdf-total-cell">
            {{ locationEdwSummaryReport.response.totaltotalStops }}
          </td>
          <td class="pdf-total-cell">
            {{ locationEdwSummaryReport.response.totaltotalPkgs }}
          </td>
          <td class="pdf-total-cell">
            {{ locationEdwSummaryReport.response.totalnumOfTotalStopswithEDW }}
          </td>
          <td class="pdf-total-cell">
            {{ locationEdwSummaryReport.response.totalnumOfTotalStopsEDWMet }}
          </td>
          <td class="pdf-total-cell">
            {{
              locationEdwSummaryReport.response.totalpercentOfTotalStopsEDWMet
            }}
          </td>
          <td class="pdf-total-cell">
            {{
              locationEdwSummaryReport.response.totalnumOfCommittedStopswithEDW
            }}
          </td>
          <td class="pdf-total-cell">
            {{
              locationEdwSummaryReport.response.totalnumOfCommittedStopsEDWMet
            }}
          </td>
          <td class="pdf-total-cell">
            {{
              locationEdwSummaryReport.response
                .totalpercentOfCommittedStopsEDWMet
            }}
          </td>
        </tr>
      </table>
    }
  </ng-container>
</app-pdf-report-generator>
